<template>
  <el-tabs class="tree-tabs" tab-position="left" v-model="activeName" @tab-click="handleClick" v-if="showLeftSide">
    <el-tab-pane v-for="(v, i) in ws" :key="i">
      <span slot="label" :title="v.SentryBoxName">
          <el-badge is-dot :hidden="v.showDot" class="item">
              {{v.SentryBoxName.length > 10 ? v.SentryBoxName.substr(0,10) + '...' : v.SentryBoxName}}
          </el-badge>
      </span>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { getUserId, getLoginSentryId, getToken } from "@/utils/service";
import Ws from "@/utils/ws";
import treeMenu from "@/minxs/treeMenu";

import {
  parkInPubSub,
  parkOutPubSub,
  userInfoPubSub,
  realInListPubSub,
  realOutListPubSub,
  blackParkInPubSub,
  spotNumPubSub,
} from "../../../service/pubsub/index";
export default {
  name: "treeTabs",
  mixins: [treeMenu],
  data() {
    return {
      activeName: '0',
    };
  },
  watch: {
    tenantId: function (v, o) {
      this.$router.push(`/home/tenant`);
      this.server(o);
    },
    isInitWs(v) {
      if (v) {
        this.closeWs();
        this.ws = null;
      }
    },
    treeSentryId(v) {
      if (v && v !== ''){
        this.sentryId = v;
        this.server();
      }
    },
    gateIdsSortStr: function () {
      // console.log('gateIdsSortStr')
      this.server();
    },
    autoCompleteSelect: function (v) {
      // console.log('autoCompleteSelect', v);
      this.parkTo(v)
    },
    moreWsDataStr: 'initWsTab',
    moreBlackParkInStr: 'initWsTab',
    showPassInStr(v) {
      this.ShowPassIn = JSON.parse(v);
      setTimeout(() => {
        if (!this.ShowPassIn[this.moreBlackParkIn.lastKey]) this.$store.dispatch("SETMoreBlackParkIn", {obj: {}, SentryBoxId: this.moreBlackParkIn.lastKey, key: 'clear'});
        if (this.wsOrderArr && this.wsOrderArr.length === 0 && this.moreBlackParkIn[this.moreBlackParkIn.lastKey].length > 0 && !this.showOrderDetail && this.ShowPassIn[this.moreBlackParkIn.lastKey]) {
          // console.log(this.ShowPassIn[this.moreBlackParkIn.lastKey], this.moreBlackParkIn[this.moreBlackParkIn.lastKey])
          if (!this.gateId){
            this.$store.dispatch("SetPayOrderGateId", parseInt(this.moreBlackParkIn[this.moreBlackParkIn.lastKey][0].park_lot_gate_id));
            this.$store.dispatch("SetTabsGateId", this.moreBlackParkIn[this.moreBlackParkIn.lastKey][0].park_lot_gate_id);
          }
          this.$store.dispatch("GetShowOrderDetail", true);
        }
        if (this.moreBlackParkIn[this.moreBlackParkIn.lastKey].length > 0 && this.ShowPassIn[this.moreBlackParkIn.lastKey]) blackParkInPubSub.publish(this.moreBlackParkIn[this.moreBlackParkIn.lastKey][0]);
      }, 700)
    },
  },
  computed: {
  },
  mounted() {
    this.sentryId = getLoginSentryId() ? Number(getLoginSentryId()) : undefined;
    // this.server();
    this.checkActive();
    // this.initWs();
    // this.refreshData();
  },
  beforeDestroy() {
    this.$store.dispatch("SetParkLotId", "");
    this.$store.dispatch("SetGateIds", []);
    this.closeWs();
  },
  methods: {
    initWs(index) {
      try {
        // console.log(url)
        this.ws[index].ws = new Ws({
          url: this.getBaseUrl(),
          // duration: 30 * 1000 * 60,
          duration: 10000,
          token: getToken(),
          connecting: (data) => {
            let Data = JSON.parse(data);
            // console.log('ws--log--', Data);
            if (Data === '登陆已过期') {
              this.closeWs();
              this.$store.dispatch("LogOut");
              this.$router.push("/login");
            }
            this.connectWsData(Data).then(wsObj => {
              switch (wsObj.key) {
                case 'parkIn':
                  if (this.ws[index].SentryBoxId === parseInt(sessionStorage.getItem('sentryId'))) {
                    parkInPubSub.publish(Data);
                  }
                  break;
                case 'parkOut':
                  this.$store.dispatch('SETMoreWsData', {obj: wsObj, SentryBoxId: this.ws[index].SentryBoxId, key: 'moreWsData'});
                  if (this.ws[index].SentryBoxId === parseInt(sessionStorage.getItem('sentryId'))) {
                    if (wsObj.message_type === '5' && wsObj.freeOrderShow !== '0') {
                      setTimeout(() => {
                        this.pubOrder(wsObj);
                        parkOutPubSub.publish(Data);
                      }, 200);
                    } else if (wsObj.message_type === '6') {
                      this.pubOrder(wsObj);
                      parkOutPubSub.publish(Data);
                    }
                  }
                  break;
                case 'blackParkIn':
                  if (Data.message_type === "5") Data.SentryId = this.ws[index].SentryBoxId;
                  this.$store.dispatch('SETMoreBlackParkIn', {obj: Data, SentryBoxId: this.ws[index].SentryBoxId, key: 'moreBlackParkIn'});
                  setTimeout(() => {
                    this.ShowPassIn = JSON.parse(this.$store.state.layout.showPassInStr);
                    if (this.ShowPassIn[this.ws[index].SentryBoxId] && this.ws[index].SentryBoxId === parseInt(sessionStorage.getItem('sentryId'))) {
                      if (this.wsOrderArr && this.wsOrderArr.length === 0 && !this.showOrderDetail) {
                        if (!this.gateId && Data.message_type !== "5") {
                          this.$store.dispatch("SetPayOrderGateId", parseInt(Data.park_lot_gate_id));
                          this.$store.dispatch("SetTabsGateId", Data.park_lot_gate_id);
                        }
                        this.$store.dispatch("GetShowOrderDetail", this.moreBlackParkIn[this.moreBlackParkIn.lastKey].length > 0);
                      }
                      blackParkInPubSub.publish(Data);
                    }
                  }, 700);
                  break;
                case 'realInOutList':
                  realInListPubSub.publish(Data.passInResult);
                  realOutListPubSub.publish(Data.passOutResult);
                  break;
                case 'userInfo':
                  userInfoPubSub.publish(Data);
                  break;
                case 'spotNum':
                  spotNumPubSub.publish(Data.SpotNum);
                  break;
                case 'parkOut2':
                  this.$store.dispatch('SETMoreWsData', {obj: wsObj, SentryBoxId: this.ws[index].SentryBoxId, key: 'moreWsData'});
                  if (wsObj.freeOrderShow !== '0' && this.ws[index].SentryBoxId === parseInt(sessionStorage.getItem('sentryId')))this.pubOrder(wsObj);
                  break;
                case 'camStatusData':
                  if (this.ws[index].SentryBoxId === parseInt(sessionStorage.getItem('sentryId'))) {
                    this.camStatusData = Data.data;
                  }
                  break;
              }
            });
          },
          success: () => {
            this.checkActive();
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
    checkActive() {
      let { ParkLotId, GateId, GateName } = this.$route.params;
      if (Number(ParkLotId) && Number(GateId) && GateName && this.ws) {
        this.ws.forEach((v, i) => {
          setTimeout(() => {
            this.sendMsgToWs({
              ParkLotId: v.ParkLotId,
              SentryBoxId: v.SentryBoxId,
            }, i);
          }, (i + 1) * 100);
          setTimeout(() => {
            this.sendMsgToWs({
              ParkLotId: v.ParkLotId,
              SentryBoxId: v.SentryBoxId,
              MsgType: 'camStatus'
            }, i)
          },(i + 2) * 100)
          if (v.camTime) {
            clearInterval(v.camTime)
            v.camTime = null
          }
          v.camTime = setInterval(() => {
            this.sendMsgToWs({
              ParkLotId: v.ParkLotId,
              SentryBoxId: v.SentryBoxId,
              MsgType: 'camStatus'
            }, i);
          }, 60000)
        })
      }
    },
    // 获取菜单
    async server(oldTenantId) {
      let res = await this.getTreeSentryBox();
      // console.log(res, oldTenantId);
      if (res.data.length > 0) {
        this.ws = [];
        res.data.forEach(v => {
          let arr = v.Node.map(vv => {
            // this.moreWsData[vv.Id] = [];
            // this.moreBlackParkIn[vv.Id] = [];
            this.$store.dispatch("SETMoreWsData", {obj: {}, SentryBoxId: vv.Id, key: 'moreWsData'});
            this.$store.dispatch("SETMoreBlackParkIn", {obj: {}, SentryBoxId: vv.Id, key: 'moreBlackParkIn'});
            // console.log(vv.Id, this.moreBlackParkIn, this.moreWsData)
            return {SentryBoxId: vv.Id, SentryBoxName: vv.Name, ParkLotId: v.Id, ParkLotName: v.Name, ShowPassIn: Boolean(vv.ShowPassIn), ws: null, camTime: null};
          })
          this.ws = this.ws.length === 0 ? arr : this.ws.concat(arr);
        })
        let ShowPassInArr = {}
        this.ws.forEach(v => {
          ShowPassInArr[v.SentryBoxId] = v.ShowPassIn;
        });
        this.$store.dispatch("SetShowPassInStr", JSON.stringify(ShowPassInArr));
        // console.log(this.$store.state.layout.showPassInStr)
        this.initJump(res.data, oldTenantId).then(val => {
          if (val.type === 1) {
            this.parkTo(val.url);
          } else {
            this.$router.push(val.url);
            this.parkTo(val.url);
          }
        });
      } else {
        this.data = [];
        this.$router.push(`/home/tenant/0/无数据/0/无数据`);
      }
    },
    // 点击路由
    parkTo(data) {
      // console.log(data)
      return new Promise(resolve => {
        this.ws.forEach((v, i) => {
          if (!v.ws) {
            this.initWs(i);
          }
        });
        this.storageRouter(data).then(res => {
          if (data !== this.autoCompleteSelect) {
            this.$store.dispatch("SETAutoCompleteSelect", data);
            this.refreshVideo(res.sentryId);
          }
          this.ws.forEach((v, i) => {
            if (v.SentryBoxId === parseInt(res.sentryId)) {
              this.activeName = String(i)
            }
          })
          this.$store.dispatch("SETMoreWsData", {obj: {}, SentryBoxId: parseInt(res.sentryId), key: 'moreWsData'});
          this.$store.dispatch("SETMoreBlackParkIn", {obj: {}, SentryBoxId: parseInt(res.sentryId), key: 'moreBlackParkIn'});
          this.$store.dispatch("SetPayOrderGateId", undefined);
          this.$store.dispatch("SetTabsGateId", undefined);
          this.ws.forEach((v, i) => {
            setTimeout(() => {
              this.sendMsgToWs({
                ParkLotId: v.ParkLotId,
                SentryBoxId: v.SentryBoxId,
              }, i);
            }, (i + 1) * 100);
            setTimeout(() => {
              this.sendMsgToWs({
                ParkLotId: v.ParkLotId,
                SentryBoxId: v.SentryBoxId,
                MsgType: 'camStatus'
              }, i)
            },(i + 2) * 100)
          });
          this.refreshTreeSentryBox(res.ParkLotId, res.sentryId).then(bool => {
            resolve(bool);
          });
          this.$nextTick(() => {
            this.$emit("changeRouter");
          });
        });
      })
    },
    //发送socket数据
    sendMsgToWs(obj, i) {
      try {
        // obj.IsOpenStream = Number(getRoleCode() === "tenantAdmin" || getRoleCode() === "internalAdmin");
        obj.IsOpenStream = 1;
        obj.TenantUserId = Number(getUserId());
        obj.LastLoginTime = sessionStorage.getItem("lastLoginTime");
        let hartObj = Object.assign({}, obj)
        delete hartObj.MsgType
        if (this.ws[i].ws) {
          this.ws[i].ws.ws.send(JSON.stringify(obj));
          this.ws[i].ws.setHeartMsg(JSON.stringify(hartObj));
        }
      } catch (error) {
        console.log(error);
      }
    },
    closeWs() {
      if (this.ws && this.ws.length > 0){
        this.ws.forEach(v => {
          v.ws.close();
          v.ws.onclose = function () {
            console.log('websocket 关闭')
          }
        })
      }
    },
    handleClick() {
      this.$router.push(`/home/tenant/${this.ws[this.activeName].ParkLotId}/${this.ws[this.activeName].ParkLotName}/${this.ws[this.activeName].SentryBoxId}/${this.ws[this.activeName].SentryBoxName}`);
      this.parkTo(`/home/tenant/${this.ws[this.activeName].ParkLotId}/${this.ws[this.activeName].ParkLotName}/${this.ws[this.activeName].SentryBoxId}/${this.ws[this.activeName].SentryBoxName}`).then(() => {
        // console.log(this.$route.params.GateId)
        this.moreWsData.lastKey = parseInt(this.$route.params.GateId);
        this.moreBlackParkIn.lastKey = parseInt(this.$route.params.GateId);
        if (this.moreWsData[parseInt(this.$route.params.GateId)].length > 0) {
          this.moreWsData[parseInt(this.$route.params.GateId)].forEach(v => {
            this.pubOrder(v);
            this.$store.dispatch("SETMoreWsData", {obj: v, SentryBoxId: this.moreWsData.lastKey, key: 'moreWsData'});
          })
        } else {
          this.$store.dispatch("SETMoreWsData", {obj: {}, SentryBoxId: this.moreWsData.lastKey, key: 'moreWsData'});
        }
        // console.log(this.moreBlackParkIn[this.moreBlackParkIn.lastKey], this.$store.state.order.payOrderGateI)
        let moreBlackParkIn = this.moreBlackParkIn[this.moreBlackParkIn.lastKey].filter(v => {return v.message_type !== '5' && v.message_type !== '32' });
        // console.log(moreBlackParkIn)
        setTimeout(() => {
          this.ShowPassIn = JSON.parse(this.$store.state.layout.showPassInStr);
          if (this.ShowPassIn[this.moreBlackParkIn.lastKey] && moreBlackParkIn.length > 0) {
            if (!this.gateId) {
              this.$store.dispatch("SetPayOrderGateId", parseInt(moreBlackParkIn[0].park_lot_gate_id));
              this.$store.dispatch("SetTabsGateId", moreBlackParkIn[0].park_lot_gate_id);
              this.$store.dispatch("GetShowOrderDetail", true);
            }
            moreBlackParkIn.forEach(v => {
              // console.log(v)
              this.$store.dispatch("SETMoreBlackParkIn", {obj: v, SentryBoxId: this.moreBlackParkIn.lastKey, key: 'moreBlackParkIn'});
              blackParkInPubSub.publish(v);
            })
          }
        }, 2000)
      });
      this.refreshVideo(this.ws[this.activeName].SentryBoxId);
    },
    initWsTab() {
      let moreWsData = JSON.parse(this.moreWsDataStr);
      let moreBlackParkIn = JSON.parse(this.moreBlackParkInStr);
      let keys = Object.keys(moreBlackParkIn);
      keys.forEach(v => {
        if (v !== 'lastKey') {
          moreBlackParkIn[v] = moreBlackParkIn[v].filter(val => {return val.message_type !== '5' && val.message_type !== '32' });
        }
      });
      this.ws.forEach((v, i) => {
        moreBlackParkIn[v.SentryBoxId] = v.ShowPassIn ? moreBlackParkIn[v.SentryBoxId] : [];
        v.showDot =  this.activeName === String(i) ? true : moreBlackParkIn[v.SentryBoxId].length === 0 && moreWsData[v.SentryBoxId].length === 0;
      });
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss">
  .tree-tabs{
    .el-tabs__item{
      .el-badge__content.is-fixed{
        top: 9px;
      }
    }
  }
</style>
